module.exports = __webpack_public_path__ + "static/img/reqiqiu.557ef5ed.svg";